<script setup lang="ts">
import { computed } from "vue";
import { getTexturedSVG } from "@/utilities/SVGPreview";
import { makerjs } from "../../../source/js/shared/rendering/makerjs";
import OptionSelector from "@/components/UI/OptionSelector.vue";
import OptionSelectorWrapper from "@/components/UI/OptionSelectorWrapper.vue";

const props = defineProps<{
	value: string;
	name: string;
	idPrefix: string;
}>();

const i18n = window.measurementSelectorVariables.i18n;
const front = computed(() => {
	return i18n.sideSelection.settings.topSide;
});
const back = computed(() => {
	return i18n.sideSelection.settings.backSide;
});

const svgFront = computed(() => {
	return getTexturedSVG(
		getRectangle(),
		front.value.color,
		front.value.appearance,
		"xMinYMin slice"
	);
});

const svgBack = computed(() => {
	return getTexturedSVG(
		getRectangle(),
		back.value.color,
		back.value.appearance,
		"xMinYMin slice"
	);
});

function getRectangle() {
	const rectangle = new makerjs.models.Rectangle(170, 120);

	// @ts-expect-error rectangle is an instance of IModel
	rectangle.layer = "shape";
	return makerjs.exporter.toSVG(rectangle, {
		useSvgPathOnly: true,
		stroke: "none",
	});
}
</script>
<template>
	<option-selector-wrapper>
		<!-- front / side-a -->
		<option-selector
			:is-active="value === 'topSide'"
			value="topSide"
			:image="svgFront"
			:rawImage="true"
			:label="front.label"
			:onInput="() => $emit('input', 'topSide')"
			name="measurements[side_selection]"
			:activeValue="value"
		/>
		<!-- back / side-b -->
		<option-selector
			:is-active="value === 'backSide'"
			value="backSide"
			:image="svgBack"
			:rawImage="true"
			:label="back.label"
			:onInput="() => $emit('input', 'backSide')"
			name="measurements[side_selection]"
			:activeValue="value"
		/>
	</option-selector-wrapper>
</template>
